import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

export default function ShoppingCart() {
  const dispatch = useDispatch()

  const cart = useSelector((state) =>
    state.cart.itens.filter((item) => item.qtde > 0)
  )

  const totalQtde = useSelector((state) => {
    return state.cart.itens.reduce(
      (acc, cur) => (acc += cur.qtde ? cur.qtde : 0),
      0
    )
  })

  return (
    <div
      className='shopping-cart'
      style={{
        position: 'fixed',
        right: '2px',
        bottom: '10px',
        height: '70%',
        width: '20%',
        overflowX: 'hidden',
        overflowY: 'auto',
      }}
    >
      <h2 className='title text-center' style={{ color: 'white' }}>
        Carrinho de Cotações
        {totalQtde > 0 && (
          <span
            className='badge badge-pill'
            style={{
              cursor: 'pointer',
              backgroundColor: 'white',
              color: '#c9302c',
            }}
            onClick={() => dispatch({ type: 'CLEAR_CART' })}
          >
            Limpar carrinho
          </span>
        )}
      </h2>

      {cart.map((item) => (
        <div
          key={item.codipro + item.foto}
          className='row cart'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            marginLeft: '5px',
            marginTop: '10px',
          }}
        >
          <div style={{ marginLeft: '5px', width: '150px' }}>
            {item.descricao}
          </div>

          <div
            style={{
              marginRight: '5px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div
              className='btn btn-outline-success'
              onClick={() =>
                dispatch({ type: 'ADD_TO_CART', item: { ...item, qtd: 1 } })
              }
            >
              <span className='glyphicon glyphicon-plus' />
            </div>

            <div>{item.qtde}</div>

            <div
              className='btn btn-outline-success'
              onClick={() =>
                dispatch({ type: 'SUBTRACT_FROM_CART', item: item })
              }
            >
              <span className='glyphicon glyphicon-minus' />
            </div>
          </div>
        </div>
      ))}

      {totalQtde > 0 && (
        <Link to='/cotacao' className='text-center'>
          <span
            className='badge badge-pill'
            style={{
              cursor: 'pointer',
              alignSelf: 'center',
              backgroundColor: 'white',
              color: '#c9302c',
              marginTop: '15px',
              marginBottom: '450px',
              fontSize: '15px',
            }}
          >
            ENVIAR COTAÇÃO
          </span>
        </Link>
      )}
      {totalQtde == 0 && (
        <span
          className='badge badge-pill'
          style={{
            alignSelf: 'center',
            backgroundColor: 'white',
            color: '#c9302c',
            marginTop: '15px',
            marginBottom: '450px',
            fontSize: '15px',
          }}
        >
          Nenhum item no carrinho
        </span>
      )}
    </div>
  )
}
